import { conditionFilter } from "@root/lib/common.ts";
import {
  QueryAttribute,
  AttributeInfo,
  createAttr,
  updateAttr,
  deleteAttr
} from "@/graphql/Attribute.gql";
import { resRest } from "@root/lib/utils";

export default {
  namespaced: true,
  state: {
    attrData: {
      datalist: [],
      pageInfo: {
        totalCount: 0
      }
    },
    PageInput: {
      pageNum: 1,
      pageSize: 5
    },
    params: {
      attrName: ""
    },
    conditionList: [],
    loading: true,
    editData: {}
  },
  getters: {
    attrList(state: any) {
      return state.attrData.datalist || [];
    },
    total(state: any) {
      return state.attrData.pageInfo.totalCount || 0;
    }
  },
  actions: {
    async getAttr({ commit, state, rootState }: any, data: any = null) {
      state.loading = true;

      const res = await rootState.gql.query({
        query: QueryAttribute,
        variables:
          data instanceof Object
            ? data
            : {
                pageInput: state.PageInput,
                condition: {
                  attrType: state.params.attrType,
                  locale: localStorage.getItem("localeLanguage"),
                  channel: localStorage.getItem("channel"),
                  orgCode: "default",
                  // orgCode: localStorage.getItem("org") || "default",
                  sortList: [
                    {
                      key: "createTime",
                      type: 1
                    }
                  ],
                  conditionList: [
                    conditionFilter(
                      "attrName",
                      state.params.attrName,
                      4,
                      state.conditionList
                    )
                  ]
                }
              }
      });
      state.loading = false;
      commit("setAttrData", res.data.queryAttrList);
      return res.data.queryAttrList;
    },

    async getAttributeList(
      { commit, state, rootState }: any,
      data: any = null
    ) {
      const res = await rootState.gql.query({
        query: QueryAttribute,
        variables: data
      });
      let list = {
        list: resRest(res.data, {
          path: "queryAttrList.datalist",
          node: "data"
        }),
        total: res.data.queryAttrList.pageInfo.totalCount
      };
      return list;
    },
    async getAttrInfo({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: AttributeInfo,
        variables: {
          codeList: data,
          orgCode: localStorage.getItem("org") || "default"
        }
      });
      commit("setEditData", res.data.attr[0]);
    },

    async createAttr({ rootState, commit }: any, data: any) {
      return await rootState.gql.mutate({
        mutation: createAttr,
        variables: {
          input: {
            ...data,
            locale: localStorage.getItem("localeLanguage"),
            channel: localStorage.getItem("channel"),
            orgCode: localStorage.getItem("org") || "default"
          }
        }
      });
    },
    async updateAttr({ rootState, commit }: any, data: any) {
      return await rootState.gql.mutate({
        mutation: updateAttr,
        variables: {
          input: {
            ...data,
            locale: localStorage.getItem("localeLanguage"),
            channel: localStorage.getItem("channel")
          }
        }
      });
    },

    async deleteAttr({ rootState }: any, data: any) {
      let res = await rootState.gql.mutate({
        mutation: deleteAttr,
        variables: { input: data }
      });
      return res.data;
    }
  },
  mutations: {
    setAttrData(state: any, data: any) {
      state.attrData = data;
    },
    setPageInput(state: any, data: any) {
      state.PageInput = data;
    },
    setEditData(state: any, data: any) {
      state.editData = data;
    },
    setConditionList(state: any, data: any) {
      state.conditionList = data;
    }
  }
};
